/// <reference path='../../core/services/quote.service.ts'/>
'use strict';

namespace QuoteCreator {

    import ICreateQuoteResponse = Quote.ICreateQuoteResponse;
    type IQuote = Quote.IQuote;
    type IContact = QuoteManager.IContact;

    class QuoteCreator{

        contact: IContact | null;
        contactEmail: string | null = '';
        sendEmail: boolean = TRPCONFIG.Domain.EnableAgentSendQuoteEmail;
        sharedUseFlag: boolean;
        quote: IQuote;
        quoteCreated: boolean = false;
        showLink: boolean = true;
        newsletterSignup: boolean = false;
		createClicked: boolean = false;
        quoteCreationError: boolean = false;

        sharedUse: boolean;
        basketId: string;
        registerUser: boolean;
        formName: string;
        refEmail: string;
        invalidUser: boolean;
        quoteEmailAttempts: number = 0;
        quoteEmailAttemptsLimit: number = 3;
        emailPattern: RegExp = /^\S+@\S+\.\S+[^\.]$/;

        constructor (
            private $scope: any,
            private analytics: any,
            private quoteManager: QuoteManager.QuoteManager,
            private broker: any,
            private quoteService: any,
            private $location: ng.ILocationService,
            private resourceService: Core.ResourceService,
            private currentUser: any,
            private localStorageProvider: any
        ) {
            this._initContact();

            this.$scope.$on('form:submitted-invalid', (event, form) => {
                if (form.$name === 'quoteForm') {
                    this.invalidUser = true;
                }
            });
        }

        private _initContact() {
            const currentUser = this.currentUser.get();
            const contact = currentUser && currentUser.Contact || {};
            this.contact = {
                Title: contact.Title || '',
                FirstName: contact.FirstName || '',
                LastName: contact.LastName || '',
                Email: contact.Email || '',
                MobileTel: contact.MobileTel || ''
            };
        }

        private _newPostCreateQuote(response: ICreateQuoteResponse): void {
            if (response.Error) {
                this.quoteCreationError = true;
                this.quoteCreated = false;
            } else {
                this.quote = response.Payload;
                this.quoteCreated = true;
                this.quoteEmailAttempts++;
                this.localStorageProvider.removeItem('trackingTag');
                this.refEmail = this.$scope.qc.contact.Email;

                if (this.formName === 'quoteFormNonReg') {
                    this.$scope.qc.contact.Email = '';
                }
            }
            this.createClicked = false;
        }

        private _newCreateQuote(
            contact: IContact | null = null,
            noUserCheck = false,
            trackingTag?: string,
            formName?: string
        ): ng.IPromise<Quote.ICreateQuoteResponse>{
            const EmailAddress = contact ? contact.Email : null;
            const email = EmailAddress ? { Email: EmailAddress } : null;
            let request: QuoteManager.ICreateQuoteRequest = {
                QuoteId: '',
                BasketId: this.basketId,
                SharedUse: this.sharedUseFlag,
                SendEmail: noUserCheck ? false : this.sendEmail,
                TrackingTag: trackingTag,
                EmailAddress,
                EmailSignUp: this.newsletterSignup,
                User: noUserCheck || !this.registerUser ? email : contact
            };
            this.formName = formName ? formName : '';
            return this.quoteManager.create(request);
        }

        create(
            contact: IContact,
            noUserCheck: boolean = false,
            mixPanelTag: string,
            formName: string
        ): ng.IPromise<any>{
            this.quoteCreationError = false;
			this.createClicked = true;
            this.quoteCreated = false;
			if (mixPanelTag) {
                this.analytics.track('mixpanel', mixPanelTag);
            }

            return this.localStorageProvider.getItem('trackingTag')
                .then((trackingTag) => this._newCreateQuote(contact, noUserCheck, trackingTag, formName))
                .then(result => this._newPostCreateQuote(result));
        }

        manageQuote(reference: string): void {
            this.broker.publish('quoteSelected', reference);
            this.localStorageProvider.setItem('quoteSelected', reference);
            this.$location.path('quote/manage/' + reference);
        }

        getName(str: string): string {
            return this.resourceService.get(str.toUpperCase());
        }

        public isQuoteEmailDisabled() {
            return this.quoteEmailAttempts >= this.quoteEmailAttemptsLimit;
        }
    }

    angular.module('quote').directive('quoteCreator', (): ng.IDirective => {
        return {
            restrict: 'E',
            replace: false,
            scope: {},
            controllerAs: 'qc',
            bindToController: {
                sharedUse: '=',
                basketId: '=',
                registerUser: '=',
                expanded: '=',
                expandable: '='
            },
            templateUrl: (element,attr) => {
                if(attr.templateVersion) {
                    return 'partials/booking/template?name=Agent/QuoteCreator&version='
                    +attr.templateVersion;
                }
                return 'partials/quote/quotecreator';
            },
            controller: QuoteCreator,
            transclude: true
        };
    });
}
